module.exports = __webpack_public_path__ + "static/desktop/img/iPastBook-logo-white.2c9ca789.svg";